import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 handler — if any API call returns 401, the session is invalid
// → force a clean re-login instead of showing a dead-end "Not authenticated" error
let isRedirecting = false;
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    // Don't redirect from auth endpoints themselves (let them handle their own errors)
    const isAuthEndpoint = url.includes("/auth/login") || url.includes("/auth/register") ||
                           url.includes("/auth/me") || url.includes("/auth/forgot-password") ||
                           url.includes("/auth/reset-password");
    if (status === 401 && !isAuthEndpoint && !isRedirecting && typeof window !== "undefined") {
      isRedirecting = true;
      // Brief delay so any pending toast can show
      setTimeout(() => {
        const path = window.location.pathname + window.location.search;
        // Don't loop if we're already on a public page
        if (!path.startsWith("/login") && !path.startsWith("/register") && !path.startsWith("/forgot-password")) {
          window.location.replace(`/login?next=${encodeURIComponent(path)}`);
        }
        isRedirecting = false;
      }, 200);
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
